var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Csrf from './csrf';
export var get = defineRequest('GET');
export var patch = defineRequest('PATCH');
export var put = defineRequest('PUT');
export var head = defineRequest('HEAD');
export var post = defineRequest('POST');
export var del = defineRequest('DELETE');
export var formatErrors = function (errors) {
    var parts = [];
    for (var _i = 0, _a = Object.entries(errors); _i < _a.length; _i++) {
        var _b = _a[_i], fieldName = _b[0], errorMessages = _b[1];
        var field = fieldName.replace(/_/g, ' ');
        var uniqueErrors = Array.from(new Set(errorMessages));
        parts.push(field + ": " + uniqueErrors.join(', '));
    }
    return parts.join('\n');
};
export var formatErrorsOrMessage = function (_a, fallbackMessage) {
    var message = _a.message, errors = _a.errors;
    if (fallbackMessage === void 0) { fallbackMessage = 'Failure'; }
    if (message !== undefined)
        return message;
    else if (errors !== undefined)
        return formatErrors(errors);
    else
        return fallbackMessage;
};
// Private
var jsonRequest = function (_a) {
    var url = _a.url, method = _a.method, body = _a.body, headers = _a.headers;
    return __awaiter(void 0, void 0, void 0, function () {
        var jsonHeaders, response, json, _b, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    jsonHeaders = __assign(__assign({}, headers), { "Content-Type": "application/json", "Accept": "application/json", 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-Token': Csrf.getToken() });
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 6, , 7]);
                    return [4 /*yield*/, fetch(url, { method: method, body: JSON.stringify(body), headers: jsonHeaders })];
                case 2:
                    response = _c.sent();
                    if (!(response.status !== 204)) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json()];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _b = null;
                    _c.label = 5;
                case 5:
                    json = _b;
                    return [2 /*return*/, Promise.resolve([json, response])];
                case 6:
                    error_1 = _c.sent();
                    return [2 /*return*/, Promise.reject(error_1)];
                case 7: return [2 /*return*/];
            }
        });
    });
};
function defineRequest(method) {
    var _this = this;
    return function (url, bodyOrHeaders, headers) { return __awaiter(_this, void 0, void 0, function () {
        var params, _a, json, response;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = { url: url, method: method };
                    // Flexible params (GET and HEAD have no body)
                    if (method === 'GET' || method === 'HEAD')
                        params = __assign(__assign({}, params), { headers: bodyOrHeaders });
                    else
                        params = __assign(__assign({}, params), { body: bodyOrHeaders, headers: headers });
                    return [4 /*yield*/, jsonRequest(params)];
                case 1:
                    _a = _b.sent(), json = _a[0], response = _a[1];
                    return [2 /*return*/, Promise.resolve([json, response])];
            }
        });
    }); };
}
